import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TITLES = [
  { match: (p) => p.startsWith('/oficina/cliente'), title: 'Portal do Cliente - Oficina' },
  { match: (p) => p.startsWith('/oficina'), title: 'Oficina Mecânica - Sistema de Gestão' },
  { match: (p) => p.startsWith('/agua'), title: 'Loja de Água - Cartão Fidelidade' },
  { match: (p) => p.startsWith('/financas'), title: 'Financeiro MEI/ME - Gestão Financeira' },
  { match: (p) => p.startsWith('/painel') || p === '/', title: 'Painel Central - Sistema de Gestão' },
];

const DEFAULT_TITLE = 'Sistema de Gestão Modular';

export default function RouteTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    const entry = TITLES.find((t) => t.match(pathname));
    document.title = entry ? entry.title : DEFAULT_TITLE;
  }, [pathname]);

  return null;
}
